import React from 'react';
import './Youtube.css'
import { Zoom, Slide } from 'react-awesome-reveal';
function YouTubeEmbed() {
  return (
    <div className="youtube-card">
      <h2 className="video-title">CREATOR OF THE WORLD'S LONGEST OUTDOOR MURAL</h2>
      <Zoom duration={1500}>
        <div className="video-containers">
          <iframe
            src="https://www.youtube.com/embed/8-3UNrFwQKI"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </Zoom>
      <p className="artist-name">by HIM CHATTERJEE</p>
    </div>
  );
}

export default YouTubeEmbed;
